import type { RootStateType } from '../../store';

export function selectDeviceId(state: RootStateType) {
  return state.appInfo.deviceId;
}

export function selectUserToken(state: RootStateType) {
  return state.appInfo.userToken;
}

export function selectUserTokenDecoded(state: RootStateType) {
  return state.appInfo.userTokenDecoded;
}

export function selectAccountId(state: RootStateType) {
  return state.appInfo.accountId;
}

export function selectIsOnline(state: RootStateType) {
  return state.appInfo.isOnline;
}

export function selectIsServerUp(state: RootStateType) {
  return state.appInfo.isServerUp;
}

export function selectShowSMLPricingModal(state: RootStateType) {
  return state.appInfo.showSMLPricingModal;
}

export function selectSMLUpgradePrompt(state: RootStateType) {
  return state.appInfo.smlUpgradePrompt;
}

export function selectTourActive(state: RootStateType) {
  return state.appInfo.tourActive;
}
